import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'highlightText',
    standalone: false
})
export class HighlightTextPipe implements PipeTransform {

  transform(value: any, ...args: any): any {
    if (!args || args[0] === '' || args[0] === undefined) { 
      return value;
    }

    let regex = new RegExp(args, 'gi');
    return value.replace(regex, "<b>$&</b>");
  }

}
